<template>
<div class="reg-box">
   <van-nav-bar
    title="注册"
    left-arrow
    @click-left="$router.push('/')"
  />
      <div class="reg-container">
         <router-link to="/" class="logo">
        <img src="@/assets/images/logo.png"/>
      </router-link>

     <van-field
    value="请输入手机号"
    label="手机号"
    v-model="phone_number"
  />
  <van-field
    value="请输入密码"
    label="密码"
    type="password"
    v-model="password"
  />
  <van-field
    value="请输入确认密码"
    label="确认密码"
    type="password"
    v-model="confirm_password"
  />
     <van-field
    value="请输入用户名"
    label="用户名"
    v-model="username"
  />
     <van-field
    value="请输入推荐码"
    label="推荐码"
    v-model="inviteCode"
  />

  <div class="agreement">注册登录即表示同意 <router-link to="/agreement">用户协议</router-link> 、 <router-link to="/privacy">隐私政策</router-link></div>
   <van-button type="danger" size="large" @click="doReg">注册</van-button>
   <div class="tips">
 <router-link to="/login">已有账号，前往登录</router-link>
   </div>
    
   
      </div>
  
</div>
</template>


<script>
export default {
   data() {
    return {
        'password':'',
        'confirm_password':'',
        'phone_number':'', //手机号
        'username':'', //用户昵称
        inviteCode:'', //邀请码
    };
  },
  created(){
    const code = this.$route.query.code
    if(code!=undefined && String(code).length===6){
        this.inviteCode=code
    }
  },
  methods:{
      doReg(){
        this.Post({
            'username':this.username,
            'password':this.confirm_password,
            'confirm_password':this.confirm_password,
            'phone_number':this.phone_number,
            'inviteCode':this.inviteCode,
        }, "/main/register", res => {
            if (res.states == 1) {
                this.Toast.success('注册成功');
                this.$router.replace('/user')
            }else{
                this.Toast.fail(res.msg);
            }
        });
      },
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .reg-box{
  .reg-container{
    padding: 10px;
    .logo{
      display: block;
      padding: 60px 0;
      text-align: center;
      img{
        border-radius: 8px;
        height: 120px;
      }
    }
  }
  .agreement{
    padding: 16px 0;
    font-size: 14px;
    a{
      color: #ee0a24;
    }
  }
  .tips {
    padding: 20px 0;
  }
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/reg.vue